import { render, staticRenderFns } from "./CustomPhonePicker.vue?vue&type=template&id=1b5826ab&"
import script from "./CustomPhonePicker.vue?vue&type=script&lang=js&"
export * from "./CustomPhonePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports